import './incidentAssignmentContextMenuPart.scss'

import IEntityIncident from '../../interfaces/entityIncident/IEntityIncident'
import { useMsal } from '@azure/msal-react'
import { useEffect, useState } from 'react'
import IApplicationSettings from '../../interfaces/applicationSettings/IApplicationSettings'
import StandardActionButton from '../standardButton/standardActionButton/StandardActionButton'
import GetUsers from '../../services/user/UserService'
import ICustomer from '../../interfaces/customer/ICustomer'
import IUser from '../../interfaces/user/IUser'
import { OverlayTrigger, Popover } from 'react-bootstrap'


type ComponentProps = {
  customer: ICustomer
  domain:string
  entityIncidents:IEntityIncident[]
  applicationSettings: null|undefined|IApplicationSettings
  handleIncidentAssignment: (entityIncidents:IEntityIncident[], assignToUserID:string, comment:string) => void
}


const IncidentAssignmentContextMenuPart = (props:ComponentProps) => {

  const [searchPhrase, setSearchPhrase] = useState<string>('')
  const [userSearchResult, setUserSearchResult] = useState<IUser[]>([])
  const [comment, setComment] = useState<string|null|undefined>()
  const [selectedUserID, setSelectedUserID] = useState<string|null|undefined>()

  const {instance } = useMsal()

  let user = instance.getActiveAccount()

  const hidePopover = (popoverID: string) => {
    const popover = document.getElementById(popoverID)
    popover?.style.setProperty('display', 'none')
  }

  const handleIncidentAssignment = (entityIncidents:IEntityIncident[], assignToUserID:string, comment:string) => {
    hidePopover('incident-item-assignment-popover')
    props.handleIncidentAssignment(entityIncidents, assignToUserID, comment)
  }


  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchPhrase.length > 2) GetUsers(instance, props.customer.customerID, props.domain, searchPhrase).then(changeUserSearchResult => setUserSearchResult(changeUserSearchResult))
    }, 1500)
    return () => clearTimeout(delayDebounceFn)
  }, [searchPhrase])

  let allowIncidentAssignment:boolean = false
  if (props.applicationSettings)
  {
    if (props.applicationSettings?.AllowIncidentAssignment) 
      allowIncidentAssignment = (Number.parseInt(props.applicationSettings.AllowIncidentAssignment) != 0)
  }



  const renderContextMenu:any = (entityIncidents:IEntityIncident[]) => (
    <Popover id='incident-item-assignment-popover' className='incident-item-assignment-popover' onClick={(event) => event.stopPropagation()}>
      <Popover.Header className='incident-item-assignment-popover-header'>Sæt den ansvarlige for hændelsen</Popover.Header>
      <Popover.Body className='incident-item-assignment-popover-body'>
        {
          allowIncidentAssignment &&
          <>
              <div className='warning-label'>
                Når du tildeler en hændelse, kan modtageren udføre handlinger på hændelsens dokument (fil, e-mail eller anden type), uanset hvor dokumentet ligger. Modtageren har dog ikke nødvendigvis mulighed for at åbne dokumentet, hvis det ligger et sted, vedkommende ikke har adgang til.
                Tildel derfor kun hændelser, hvor modtageren allerede har adgang til dokumentet. Ellers kan indholdet ikke vurderes.
              </div>
              <div className='assign-label'>
                Vælg en bruger og skriv en kommentar:
              </div>
              <input
                className='search-input'
                type='form-control'
                spellCheck='false'
                placeholder='Søg bruger (>3 tegn)' 
                onChange={(event) => setSearchPhrase(event.target.value)}
              />
              <div className='search-result'>
                {
                  userSearchResult &&
                  userSearchResult.map((user:IUser, index:number) => {
                    if (index < 10)
                      return (
                        <div id={'search-result-item-' + index} className='search-result-item'
                          onClick={() => setSelectedUserID(user.userPrincipalName)}
                        >
                          {user.displayName + ' ' + (user.department ? '(' + user.department + ')' : '')}
                        </div>
                      )
                    else 
                      if (index == 10)
                        return (
                          <div className='search-result-limit'>
                            (Viser kun ti)
                          </div>
                        )
                    })
                }
              </div>
              <div className='assign-user-id'>
                {selectedUserID}
              </div>
              <input 
                className='comment-input' 
                spellCheck='false' 
                placeholder='Kommentar (<200 tegn)' 
                onChange={(event: React.FormEvent<HTMLInputElement>) => setComment(event.currentTarget.value)}>
              </input>
              <div className='comment-button-container'>
                <StandardActionButton key='incident-cancellation-correct-button' status={((!!selectedUserID && !!comment) ? 'enabled' : 'disabled')} id='incident-assignment-button' title='Tildel' onClick={() => {if (selectedUserID && comment) handleIncidentAssignment(entityIncidents, selectedUserID, comment)}} />
              </div>    
            </>    
        }
      </Popover.Body>
    </Popover>
  )

  return (  
    <> 
      <OverlayTrigger trigger={['click']} rootClose={true} placement='auto' overlay={renderContextMenu(props.entityIncidents) }>
        <div>
          Tildel ansvar...
        </div>
      </OverlayTrigger>
    </>
  )
}

export default IncidentAssignmentContextMenuPart